import moment from "moment";

/** Gets the next 15 minute interval based on the current date and time */
const getNext15MinuteInterval = () => {
  const current = moment(new Date());
  const currentMinutes = current.minutes();
  const next15minutes = Math.ceil(currentMinutes / 15) * 15;

  return current
    .add(next15minutes - currentMinutes, "minutes")
    .format("YYYY-MM-DDTHH:mm");
};

/** Checks if the input represents "no date" (matches original VB logic) */
const noDate = (datDate: any): boolean => {
  try {
    const m = moment(datDate);

    // Invalid date input
    if (!m.isValid()) {
      return true;
    }

    // Date part is on or before 1900-01-01
    if (m.clone().startOf("day").isSameOrBefore(moment("1900-01-01"), "day")) {
      return true;
    }

    // Exact match to today's midnight (includes date-only inputs on current day)
    if (m.isSame(moment().startOf("day"))) {
      return true;
    }

    return false;
  } catch (ex) {
    return true;
  }
};

const isDueAfterToday = (dueDate: any): boolean => {
  const mDue = moment(dueDate);
  if (!mDue.isValid()) return false;

  // Compare to midnight of today
  return mDue.isAfter(moment().startOf("day"));
};

export { getNext15MinuteInterval, noDate, isDueAfterToday };
